<script lang="ts">
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let bannerType: 'info' | 'error' = 'info';

    const iconByType = {
        'info': 'info',
        'error': 'exclamation'
    }
</script>

<div class="info-banner banner-type-{bannerType}">
    <IconedContent iconColor="inherit"
                   orientation="vertical"
                   align="center"
                   justify="center"
                   icon="{iconByType[bannerType]}">

        <slot name="text"/>
    </IconedContent>

    <div>
        <slot/>
    </div>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .info-banner {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: @spacing-xl @spacing-l;
        gap: @spacing-xl;
        border-radius: @border-radius-large;

        &.banner-type-info {
            background-color: #EAEEFF;
            color: var(--accent-blue-new);
            border: 1px solid var(--accent-blue-new);
        }

        &.banner-type-error {
            background-color: #FEE9F0;
            color: var(--danger-red);
            border: 1px solid var(--danger-red);
        }
    }
</style>